<template>
    <div
        :class="['market-block', {
            unfold
        }]"
    >
        <div class="slider">
            <div class="gabarit-decoration">
                <div class="mask">
                    <div v-for="slide in layout.data"
                    :style="{
                        backgroundImage: `url(${slide.image.url})`
                    }">
                        <img
                            :src="slide.image.url"
                            :alt="slide.image.alt"
                            :title="slide.image.title"
                            class="seo-image"
                        />
                    </div>
                    <div class="mask-sizer">
                        <transition>
                            <div
                                v-if="currentSlide"
                                :key="currentSlide.id"
                                :class="[
                                    'image-gabarit',


                                ]"
                            >
                                <div
                                    class="image-holder"
                                    :style="{
                                        backgroundImage: `url(${currentSlide.image.url})`
                                    }"
                                >
                                    <img
                                        :src="currentSlide.image.url"
                                        :alt="currentSlide.image.alt"
                                        :title="currentSlide.image.title"
                                        class="seo-image"
                                    />
                                </div>
                                <div
                                    class="image-overlay"
                                />
                            </div>
                        </transition>
                    </div>
                </div>
                <transition>
                    <Swiper
                        v-if="!unfold && currentSlide"
                        :index="idx"
                        :image-index="imgIdx"
                        :data="layout.data"
                        @index-change="onIndexChange"
                        @image-change="onImageChange"
                        @next="handleNext"
                        @previous="handlePrevious"
                    />
                </transition>
            </div>
            <div class="gabarit-pagination">
                <router-link
                    :key="market.id"
                    v-for="(market, i) in layout.data"
                    :to="$trl({
                        name: 'Market',
                        params: {
                            slug: market.customslug || market.slug,
                            locale: $route.params.locale
                        }
                    })"
                    @click.native="idx = i"
                    @mouseover.native="idx = i"
                    :class="[
                        'pagination-link',
                        {
                            active: i === idx,
                            before: i < idx,
                            after: i > idx
                        }
                    ]"
                >
                    <div class="relative-box">
                        <span class="caption">{{market.name}}</span>
                        <IconArrow
                            :direction="'right'"
                            :color="'#FFFFFF'"
                            class="icon-arrow"
                            width="34"
                            height="29"
                        />
                        <span class="cover-caption">
                            <span class="letter-sizer">
                                <span class="letter">
                                    <span class="line">{{market.name}}</span>
                                </span>
                            </span>
                            <!-- <SplitCaption :caption="market.name"/> -->
                        </span>
                    </div>
                </router-link>
            </div>
            <div class="spacer"></div>
        </div>
        <router-view/>
    </div>
</template>
<script>
import Slidable from '@/components/MixinSlidable'
import SplitCaption from '@/components/SplitCaption'
import Swiper from '@/components/layout/MarketBlock/Swiper.vue'
import IconArrow from '@/components/IconArrow'
export default {
    mixins: [Slidable],
    components: {
        SplitCaption,
        Swiper,
        IconArrow
    },
    props: {
        layout: {
            type: Object,
            default() {}
        }
    },
    data(){
        return {
            imgIdx: 0
        }
    },
    computed: {
        count() {
            return this.layout.data.length
        },

        currentSlide() {
            return this.layout.data[this.imgIdx]
        },
        unfold() {
            return this.$route.name === 'Markets'
        }
    },
    watch: {
        '$route' (to) {
            const { slug } = to.params
            if(slug) {
                this.idx = this.layout.data.map(_ => _.customslug || _.slug).indexOf(slug)
            }
        }
    },
    created() {
        const { slug } = this.$route.params
        if(slug) {
            this.idx = this.layout.data.map(_ => _.customslug || _.slug).indexOf(slug)
        }
    },
    methods: {
        onImageChange(index) {
            this.imgIdx = index
        },
        onIndexChange(index) {
            this.idx = index

            this.updateRoute()
        },
        handleNext() {
            this.next(true)
            this.updateRoute()
        },
        handlePrevious() {
            this.previous(true)
            this.updateRoute()
        },
        updateRoute() {
            this.$router.push(this.$trl({
                name: 'Market',
                params: {
                    slug: this.layout.data[this.idx].customslug || this.layout.data[this.idx].slug,
                }
            }))
        }
    }
}
</script>
<style lang="sass" scoped>
@import "@/styles/vars.sass"
.slider
    position: relative
    margin-bottom: 10.41667%
    overflow: hidden
    @media print
        margin-bottom: 1.2cm
.gabarit-decoration
    box-sizing: content-box
    position: relative
    height: 41.875vw
    @include media-breakpoint-up($xxl)
        height: 50.25em
    @include media-breakpoint-down($md)
        height: 59vw
    @media print
        height: auto
.spacer
    height: 25vh
    position: relative
    background-image: url('../../../assets/cross-red-fade.svg')
    background-size: 45px 45px
    background-position: 0 0
    width: 90%
    margin: 0 auto
    z-index: -1
    // @include media-breakpoint-down($md)
    //     display: none
    @media print
        display: none
    .unfold &
        transform: translateX(-50%)
        background-image: none
.mask
    height: 100%
    overflow: hidden
    position: relative
    will-change: transform
    transition: transform .625s
    .unfold &
        transform: translateX(-50%)
.market-block
    position: relative
    @include media-breakpoint-up($xxl)
        margin-left: calc((-100vw + 1920px) * 0.5)
        margin-right: calc((-100vw + 1920px) * 0.5)
    &:before
        content: ""
        display: block
        width: 90%
        height: 150px
        background-image: url('../../../assets/cross-red-fade.svg')
        background-size: 45px 45px
        background-position: 0 0
        position: absolute
        top: -150px
        left: 50%
        transform: translateX(-50%)
        @media print
            display: none
.market-block.unfold
    &:before
        display: none
.mask-sizer
    width: 100%
    height: 100%
    position: relative
    transition: transform .625s
    transform: translateX(0%)
    .unfold &
        transform: translateX(25%)
$timing: 1.2s
.image-gabarit
    height: 100%
    width: 100%
    background-size: cover
    background-position: 50% 50%
    background-repeat: no-repeat
    position: absolute
    left: 0
    top: 0
    will-change: opacity, transform
    transition: transform $timing 1s, opacity 0s 1s
    transform: translateX(0%)
    opacity: 1
    overflow: hidden

    .unfold &
        transform: translateX(0%)
    &.v-enter-active
        transition: transform $timing cubic-bezier(.65,0,.25,1)
    &.v-leave-active
        transition: transform $timing cubic-bezier(.65,0,.25,1)
    &.v-enter
        transform: translateX(100%)
        .unfold
            transform: translateX(25%)

        .image-holder
            transform: translateX(-62.5%)
    &.v-leave-to
        transform: translateX(-100%)
        .image-holder
            transform: translateX(62.5%)

.image-overlay
    position: absolute
    left: 0
    top: 0
    width: 100%
    height: 100%
    background-color: rgba(0,0,0,.2)
.image-holder
    width: 100%
    height: 100%
    background-position: 50% 50%
    background-size: cover
    background-repeat: no-repeat
    will-change: transform
    transform: translateX(0%)
    transition: transform $timing cubic-bezier(.65,0,.25,1)
.gabarit-pagination
    position: absolute
    width: 50%
    right: 0
    top: 4.625em
    display: flex
    flex-direction: column
    height: auto
    bottom: 0
    background-color: #ff2b2a
    justify-content: center
    will-change: transform
    transition: transform .625s
    transform: translateX(100%)
    // @include media-breakpoint-down($hd)
    //     width: 62.5%
    // @include media-breakpoint-down($lg)
    //     width: 75%
    @include media-breakpoint-down($md)
        width: 100%
        height: auto
        padding-top: 10%
        padding-bottom: 10%
        top: 0
    @media print
        position: static
        background-color: transparent
        width: auto
        top: initial
        height: auto
        display: none
        margin-left: 9.6%
        margin-right: 9.6%
        page-break-inside: avoid
        break-inside: avoid
        .unfold &
            display: block

    .pagination-link
        white-space: nowrap
        .relative-box
            position: relative
            opacity: 0
            transform: translateX(60px)
            .icon-arrow
                position: absolute
                top: 50%
                left: 0
                opacity: 0
                will-change: opacity, transform
                transform: translateY(-50%) translateX(-500%)
                transition: opacity 0.5s 0.2s, transform 0.5s 0.2s
        &.active
            .relative-box
                .icon-arrow
                    opacity: 1
                    transform: translateY(-50%) translateX(-225%)
                    @include media-breakpoint-down($hd)
                        transform: translateY(-50%) translateX(-225%)
    .unfold &
        transform: translateX(0%)
        .pagination-link
            .relative-box
                opacity: 1
                transform: translateX(0px)
.pagination-link
    color: #ffffff
    font-size: 1.40625vw
    text-decoration: none
    display: block
    width: 70%
    margin-left: auto
    margin-right: auto
    position: relative
    will-change: transform
    transition: transform .3s
    .relative-box
        will-change: transform, opacity
        transition: transform .3s, opacity .3s
    @for $i from 0 through 10
        &:nth-child(#{$i + 1})
            .relative-box
                transition-delay: .05s * $i, .05s * $i

    @include media-breakpoint-up($xxl)
        font-size: 27px
    @include media-breakpoint-down($hd)
        font-size: 14px
    @media print
        color: rgb(255, 43, 43)
        width: auto
        font-size: 20px
        margin-bottom: .3em
        margin-top: .3em
        &:after
            content: "https://www.soletanche-bachy.com" attr(href)
            font-size: 12px
            font-weight: normal
            color: #000000
            // margin-top: -.1em
            display: block

    .caption
        will-change: opacity
        transition: opacity .3s
        display: inline-block
        line-height: 1.4814814815
        letter-spacing: -0.054em
        transform-origin: 0 50%
    .cover-caption
        position: absolute
        left: 0
        top: 50%
        transform: translateY(-50%)
        white-space: normal
        font-size: 3.125vw
        font-weight: 500
        padding-bottom: .1875em

        @include media-breakpoint-up($xxl)
            font-size: 60px
        // @include media-breakpoint-down($hd)
        //     font-size: 48px
        @media print
            display: none
        /deep/ .letter-sizer
            display: block
        /deep/ .letter
            opacity: 0
            will-change: opacity
            transition: opacity .3s
            // transform: translateY(120%)
            display: block
    .line
        border-bottom: 7px solid #ffffff
    &.active
        .caption
            opacity: 0
            @include media-breakpoint-down($md)
                opacity: 1
            @media print
                opacity: 1
        .cover-caption
            // opacity: 1
            @include media-breakpoint-down($md)
                display: none
            /deep/ .letter
                opacity: 1
                transform: translateY(0%)
                transition: opacity .3s .15s
            &:after
                transition: transform .625s .3s, opacity .625s .3s
                transform: translateY(0%)
                opacity: 1
    &.before
        transform: translateY(-150%)
        @include media-breakpoint-down($md)
            transform: none
        @media print
            transform: none
    &.after
        transform: translateY(200%)
        @include media-breakpoint-down($md)
            transform: none
        @media print
            transform: none

.list-item
    display: inline-block
    margin-right: 10px

.list-enter-active, .list-leave-active
    transition: all 1s

.list-enter, .list-leave-to
    opacity: 0
    transform: translateY(30px)

</style>
